import "./vendor/turbo";
import { component } from "./web-component";

component("x-focus-reset", (self) => {
  const reset = (/** @type {Event & { target: HTMLInputElement }} */ elem) =>
    (elem.target.value = "");
  self.querySelector("input").addEventListener("focus", reset);
});

window.addEventListener('error', (e) => {
  fetch('/assets/errors', {
    method: 'POST',
    body: JSON.stringify({
      message: e.message,
      filename: e.filename,
      lineno: e.lineno,
      colno: e.colno,
      stack: e.error?.stack,
      userAgent: navigator.userAgent,
      url: location.href
    })
  });
});
